import { Stack, Typography, useTheme } from '@mui/material';
import { useAppDispatch, useAppSelector } from 'hooks/redux.hooks';
import { ClientPaginatedTable } from 'components/table';
import * as TableConfig from './tablesConfig';
import { selectTranslations } from 'state/reducers/translation.reducers';
import React, { useEffect, useState } from 'react';
import { editCountry } from 'services/global.service';

type IProps = {
	countries: Record<string, any>[];
};

export const CountriesTable: React.FC<IProps> = ({ countries }: IProps) => {
	const t = useAppSelector(selectTranslations);
	const theme = useTheme();
	const dispatch = useAppDispatch();
	const [tableData, setTableData] = useState<Record<string, any>[]>([]);

	useEffect(() => {
		setDefaultModifiedCountries();
	}, [countries]);

	const setDefaultModifiedCountries = () => {
		const modifiedCountries = countries?.map((country: any) => {
			return { ...country, editable: false };
		});
		setTableData(modifiedCountries || []);
	};

	const handleEditButtonClick = (countryId: number) => {
		const modifiedCountries = countries?.map((country: any) => {
			return { ...country, editable: countryId === country.id ? true : false };
		});
		setTableData(modifiedCountries || []);
	};

	const saveCountryChanges = (newCountryData: any) => {
		const { id, name, isForbidden, isRisky, isTaxShelter } = newCountryData;
		setDefaultModifiedCountries();
		dispatch(editCountry({ id, name, isForbidden, isRisky, isTaxShelter }, countries));
	};

	const cancelCountryChanges = () => {
		setDefaultModifiedCountries();
	};

	const updateModifiedCountries = (field: any, fieldValue: any, changedCountry: any) => {
		const modifiedCountries = countries?.map((country: any) => {
			return {
				...country,
				editable: changedCountry.id === country.id ? true : false,
				name:
					changedCountry.id === country.id
						? field === 'name'
							? fieldValue
							: changedCountry.name
						: country.name,
				isRisky:
					changedCountry.id === country.id
						? field === 'isRisky'
							? fieldValue
							: changedCountry.isRisky
						: country.isRisky,
				isTaxShelter:
					changedCountry.id === country.id
						? field === 'isTaxShelter'
							? fieldValue
							: changedCountry.isTaxShelter
						: country.isTaxShelter,
				isForbidden:
					changedCountry.id === country.id
						? field === 'isForbidden'
							? fieldValue
							: changedCountry.isForbidden
						: country.isForbidden,
			};
		});
		setTableData(modifiedCountries || []);
	};

	return (
		<Stack spacing={2}>
			<Typography variant="subtitle" color={theme.palette.root.grey}>
				{countries?.length + ' ' + t('messages.results')}
			</Typography>
			{tableData && (
				<ClientPaginatedTable
					data={TableConfig.tableData(tableData)}
					columns={TableConfig.buildColumns(
						'',
						t,
						handleEditButtonClick,
						saveCountryChanges,
						cancelCountryChanges,
						updateModifiedCountries,
						dispatch,
						tableData,
						setTableData
					)}
				/>
			)}
		</Stack>
	);
};
